import fetch from "auth/FetchInterceptor";

const PlatformTutorialsService = {};
const prefix = "/platform-tutorials";

PlatformTutorialsService.getAll = async () =>
  await fetch(`${prefix}`, {
    method: "GET",
  });

PlatformTutorialsService.getById = async (id) =>
  await fetch(`${prefix}/${id}`, {
    method: "GET",
  });

PlatformTutorialsService.create = async (data) =>
  await fetch(`${prefix}`, {
    method: "POST",
    data,
  });

PlatformTutorialsService.update = async (id, data) =>
  await fetch(`${prefix}/${id}`, {
    method: "PUT",
    data,
  });

PlatformTutorialsService.delete = async (id) =>
  await fetch(`${prefix}/${id}`, {
    method: "DELETE",
  });

export default PlatformTutorialsService;
